import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, from, of } from 'rxjs';

import { LocalStorageService } from '@app/core/services';
import { MobileAppModalContainerComponent } from './mobile-app-modal-container.component';

@Injectable()
export class MobileAppModalProvider {

  private readonly storageKey = 'SHOW_MOBILE_APP_POPUP';

  constructor(
    private modalService: NgbModal,
    private storage: LocalStorageService
  ) { }

  open(): Observable<any> {
    const shouldOpen = this.storage.get(this.storageKey);
    if (shouldOpen === 'false') {
      return of(false);
    }
    const modal = this.modalService.open(MobileAppModalContainerComponent, { windowClass: 'mt-5' });
    return from(modal.result);
  }
}
